var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isObjectLoading,
            expression: "isObjectLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isObjectLoading,
            expression: "!isObjectLoading",
          },
        ],
      },
      [
        _c("v-page-header", {
          attrs: { title: _vm.getPageTile, showPrevButton: true },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "grid-container" }, [
          _c("div", { staticClass: "grid-x" }, [
            _c(
              "div",
              {
                staticClass:
                  "cell medium-9 medium-offset-1 large-11 large-offset-0",
              },
              [
                _c("div", { staticClass: "wrapper" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasObjectFatalError,
                          expression: "hasObjectFatalError",
                        },
                      ],
                    },
                    [
                      _c("p", { staticClass: "text-center" }, [
                        _vm._v(_vm._s(_vm.objectFatalError)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.hasObjectFatalError,
                          expression: "!hasObjectFatalError",
                        },
                      ],
                    },
                    [
                      _c("v-action-buttons", {
                        attrs: {
                          items: _vm.getActionButtons,
                          isDisabled: _vm.objectFormDisabled,
                        },
                        on: { actionClicked: _vm.onClickAction },
                      }),
                      _vm._v(" "),
                      _c("v-form-message", {
                        attrs: {
                          type: "error",
                          id: "form-error",
                          message: _vm.objectError,
                        },
                        on: { onClickAction: _vm.onClickActivateDialogAction },
                      }),
                      _vm._v(" "),
                      _c("v-form-message", {
                        attrs: {
                          type: "success",
                          id: "form-success",
                          message: _vm.objectSuccess,
                        },
                        on: { onClickAction: _vm.onClickActivateDialogAction },
                      }),
                      _vm._v(" "),
                      _c("v-form-message", {
                        attrs: {
                          type: "default",
                          id: "form-activate",
                          message: _vm.objectActivateMessage,
                          autoCloseTimeout: 0,
                          showActionButtons: true,
                        },
                        on: { onClickAction: _vm.onClickActivateDialogAction },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "box" }, [
                        _c("div", { staticClass: "form-group--wrapper" }, [
                          _c("div", { staticClass: "grid-x grid-padding-x" }, [
                            _c(
                              "div",
                              { staticClass: "cell medium-12 large-6" },
                              [
                                _c("div", { staticClass: "form-block" }, [
                                  _c("h2", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("form.customer.title.customer")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group form-group--required",
                                      class: {
                                        "form-group--error":
                                          _vm.$v.object.client_number.$error,
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "form-field-client-number",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("customers.client_number")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.$v.object.client_number
                                                .$model,
                                            expression:
                                              "$v.object.client_number.$model",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "form-field-client-number",
                                          name: "client_number",
                                          placeholder: "12345678",
                                        },
                                        domProps: {
                                          value:
                                            _vm.$v.object.client_number.$model,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.$v.object.client_number,
                                              "$model",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group form-group--required",
                                      class: {
                                        "form-group--error":
                                          _vm.$v.object.company_name.$error,
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "form-field-company-name",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("customers.company_name")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.$v.object.company_name.$model,
                                            expression:
                                              "$v.object.company_name.$model",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "form-field-company-name",
                                          name: "company_name",
                                          placeholder: "Musterfirma",
                                        },
                                        domProps: {
                                          value:
                                            _vm.$v.object.company_name.$model,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.$v.object.company_name,
                                              "$model",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-group" }, [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "form-field-contact-person",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("customers.contact_person")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.object.contact_person,
                                          expression: "object.contact_person",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "form-field-contact-person",
                                        name: "contact_person",
                                        placeholder: "",
                                      },
                                      domProps: {
                                        value: _vm.object.contact_person,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.object,
                                            "contact_person",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "cell medium-12 large-6" },
                              [
                                _c("div", { staticClass: "form-block" }, [
                                  _c("h2", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "form.customer.title.hq_location"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("customers.location_number")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-control form-control--static",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                        " +
                                            _vm._s(
                                              _vm.object.headquarter
                                                .location_number
                                            ) +
                                            "\n                                                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group form-group--required",
                                      class: {
                                        "form-group--error":
                                          _vm.$v.object.headquarter.address1
                                            .$error,
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: { for: "form-field-adress1" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("form.address1"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.$v.object.headquarter.address1
                                                .$model,
                                            expression:
                                              "$v.object.headquarter.address1.$model",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "form-field-adress1",
                                          name: "address1",
                                          placeholder:
                                            _vm.$t("form.address1.plc"),
                                        },
                                        domProps: {
                                          value:
                                            _vm.$v.object.headquarter.address1
                                              .$model,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.$v.object.headquarter
                                                .address1,
                                              "$model",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-group" }, [
                                    _c(
                                      "label",
                                      { attrs: { for: "form-field-adress2" } },
                                      [_vm._v(_vm._s(_vm.$t("form.address2")))]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.object.headquarter.address2,
                                          expression:
                                            "object.headquarter.address2",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "form-field-adress2",
                                        name: "address2",
                                        placeholder:
                                          _vm.$t("form.address2.plc"),
                                      },
                                      domProps: {
                                        value: _vm.object.headquarter.address2,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.object.headquarter,
                                            "address2",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "grid-x grid-margin-x" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "cell medium-6" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group form-group--small form-group--required",
                                              class: {
                                                "form-group--error":
                                                  _vm.$v.object.headquarter
                                                    .zipcode.$error,
                                              },
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "form-field-zipcode",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("form.zipcode")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.$v.object.headquarter
                                                        .zipcode.$model,
                                                    expression:
                                                      "$v.object.headquarter.zipcode.$model",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  "loading-spinner--input":
                                                    _vm.geocodeLoading,
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "form-field-zipcode",
                                                  name: "zipcode",
                                                  placeholder:
                                                    _vm.$t("form.zipcode.plc"),
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.$v.object.headquarter
                                                      .zipcode.$model,
                                                },
                                                on: {
                                                  keyup: _vm.onChangeZipcode,
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.$v.object.headquarter
                                                        .zipcode,
                                                      "$model",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.geocodeObject.zipcode.length > 1
                                            ? _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      staticClass:
                                                        "form-control form-control--select",
                                                      attrs: {
                                                        name: "zipcode_list",
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.onSelectZipcode,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "form.zipcode.choose"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.geocodeObject
                                                          .zipcode,
                                                        function (item) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value:
                                                                  item.zipcode,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                                    " +
                                                                  _vm._s(
                                                                    item.zipcode
                                                                  ) +
                                                                  "\n                                                                "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "cell medium-6" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group form-group--small form-group--required",
                                              class: {
                                                "form-group--error":
                                                  _vm.$v.object.headquarter.city
                                                    .$error,
                                              },
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "form-field-city",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("form.city"))
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.$v.object.headquarter
                                                        .city.$model,
                                                    expression:
                                                      "$v.object.headquarter.city.$model",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  "loading-spinner--input":
                                                    _vm.geocodeLoading,
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "form-field-city",
                                                  name: "city",
                                                  placeholder:
                                                    _vm.$t("form.city.plc"),
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.$v.object.headquarter
                                                      .city.$model,
                                                },
                                                on: {
                                                  keyup: _vm.onChangeCity,
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.$v.object.headquarter
                                                        .city,
                                                      "$model",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.geocodeObject.city.length > 1
                                            ? _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      staticClass:
                                                        "form-control form-control--select",
                                                      attrs: {
                                                        name: "city_list",
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.onSelectCity,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "form.city.choose"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.geocodeObject.city,
                                                        function (item) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value:
                                                                  item.city,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                                    " +
                                                                  _vm._s(
                                                                    item.city
                                                                  ) +
                                                                  "\n                                                                "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group form-group--required",
                                      class: {
                                        "form-group--error":
                                          _vm.$v.object.headquarter.country_code
                                            .$error,
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: { for: "form-field-country" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("customers.country"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-select-country", {
                                        attrs: { id: "form-field-country" },
                                        model: {
                                          value:
                                            _vm.$v.object.headquarter
                                              .country_code.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.object.headquarter
                                                .country_code,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.object.headquarter.country_code.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group form-group--required",
                                      class: {
                                        "form-group--error":
                                          _vm.$v.object.headquarter.phone
                                            .$error,
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "form-field-phone" } },
                                        [_vm._v(_vm._s(_vm.$t("form.phone")))]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.$v.object.headquarter.phone
                                                .$model,
                                            expression:
                                              "$v.object.headquarter.phone.$model",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "tel",
                                          id: "form-field-phone",
                                          name: "phone",
                                          placeholder: _vm.$t("form.phone.plc"),
                                        },
                                        domProps: {
                                          value:
                                            _vm.$v.object.headquarter.phone
                                              .$model,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.$v.object.headquarter.phone,
                                              "$model",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group form-group--required",
                                      class: {
                                        "form-group--error":
                                          _vm.$v.object.headquarter.email
                                            .$error,
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "form-field-email" } },
                                        [_vm._v(_vm._s(_vm.$t("form.email")))]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.$v.object.headquarter.email
                                                .$model,
                                            expression:
                                              "$v.object.headquarter.email.$model",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "email",
                                          id: "form-field-email",
                                          name: "email",
                                          placeholder: _vm.$t("form.email.plc"),
                                        },
                                        domProps: {
                                          value:
                                            _vm.$v.object.headquarter.email
                                              .$model,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.$v.object.headquarter.email,
                                              "$model",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }